import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateTrustRule } from "./api";
import type { TrustRuleResponse, TrustRuleUpdateRequest } from "./api";

export interface UpdateTrustRuleVariables {
  readonly ruleId: string;
  readonly body: TrustRuleUpdateRequest;
}

// PATCH одного правила (rename / правка paths|actions / toggle is_active).
// Инвалидируем список после успеха.
export function useUpdateTrustRule(): ReturnType<
  typeof useMutation<TrustRuleResponse, Error, UpdateTrustRuleVariables>
> {
  const queryClient = useQueryClient();
  return useMutation<TrustRuleResponse, Error, UpdateTrustRuleVariables>({
    mutationFn: ({ ruleId, body }) => updateTrustRule(ruleId, body),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["trustRules"],
      });
    },
  });
}
